module.exports = __webpack_public_path__ + "static/amazingFeatureDesktop-3140145601d5e3156d4766c2b229e821.svg";